import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const SubscribedRoute = () => {
  const { userInfo } = useSelector((state) => state.auth);
  return userInfo && userInfo.isSubscribed ? (
    <div className="w-full">
      <Outlet />
    </div>
  ) : (
    <Navigate to="/join" replace />
  );
};

export default SubscribedRoute;
